<template>
    <div class="dap-filter-panel">

        <div class="data-block">

            <div class="list-arrow2"></div>

            <div v-for="(filterGroup, $idx) in options.filters" :key="$idx" class="m-t-10 relative">
                <el-button v-if="$idx === clearIndex" class="clear-all" type="text" @click="clearAll" size="small">清空筛选条件</el-button>
                <div class="data-block-title" v-if="filterGroup.name">
                    {{ filterGroup.name }}
                </div>

                <div class="select-area" v-if="filterGroup.children">
                    <div class="item" v-for="item in filterGroup.children.filter(i => !i.hide && i.type !== 'other')" :key="item.key">
                        <FilterItem
                            :filterOption="item" :selectedDict="selectedDict" :size="size"
                            @setResult="setResult">
                            <slot v-for="item in slotNames" :slot="item" :name="item"></slot>
                        </FilterItem>
                    </div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>

            <el-form :model="selectMetrics" ref="form">
                <div v-for="(metricGroup, $idx) in options.metrics" :key="$idx" class="m-t-10">
                    <div class="data-block-title" v-if="metricGroup.name">
                        {{ metricGroup.name }}
                    </div>

                    <div class="option-select-area">
                        <div class="option-item flex-normal" v-for="(item, index) in selectMetrics[metricGroup.key]" :key="item.key">
                            <el-select
                                size="mini" popper-class="global-filter-select-popper w120" class="w120 m-r-6"
                                v-model="item.key" @change="handleChangeMetricKey(item, metricGroup)">
                                <el-option
                                    v-for="metric in metricGroup.children" :key="metric.key"
                                    :value="metric.key" :label="metric.name" :disabled="isDisabled(metricGroup, metric, item)"
                                />
                            </el-select>
                            <el-select
                                size="mini" popper-class="global-filter-select-popper w90" class="m-r-6 operation-select w90"
                                v-model="item.operation" @change="handleChangeOperation(item)">
                                <el-option
                                    v-for="operation in getOperationList(item.operations)" :key="operation.key"
                                    :value="operation.value" :label="operation.label"
                                />
                            </el-select>
                            <el-form-item
                                v-if="item.operation !== 'BETWEEN'"
                                :prop="`${metricGroup.key}.${index}.value`" style="margin-bottom: 0"
                                :rules="[{required: true, message: '请输入指标'}]"
                            >
                                <el-input v-model="item.value" size="mini" style="width: 204px">
                                    <span slot="suffix">{{item.unit}}</span>
                                </el-input>
                            </el-form-item>
                            <div v-else class="range-input flex-normal f12">
                                <el-form-item
                                    :prop="`${metricGroup.key}.${index}.value`" style="margin-bottom: 0"
                                    :rules="[{required: true, message: '请输入指标'}]"
                                >
                                    <el-input v-model="item.value" size="mini" class="w90 no-border">
                                    </el-input>
                                </el-form-item>
                                <div class="c-333 m-l-2 m-r-2">-</div>
                                <el-form-item
                                    :prop="`${metricGroup.key}.${index}.value2`" style="margin-bottom: 0"
                                    :rules="[{required: true, message: '请输入指标'}]"
                                >
                                    <el-input v-model="item.value2" size="mini" class="w90 no-border">
                                    </el-input>
                                </el-form-item>
                                <div class="c-ccc m-r-4">{{item.unit}}</div>
                            </div>
                            <div
                                class="delete-icon-box hand m-l-8 flex-center"
                                @click="removeMetric(metricGroup, item)">
                                <dap-icon-svg icon-class="delete" class="delete-icon c-999 f12" />
                            </div>

                        </div>
                        <div
                            v-if="!selectMetrics[metricGroup.key] || selectMetrics[metricGroup.key].length < metricGroup.children.length"
                            class="add-item f12 flex-center hand" @click="addMetric(metricGroup)">
                            <DapIconSvg icon-class="tianjia1" class="m-r-5" />添加筛选条件
                        </div>

                        <div></div>
                        <div></div>
                        <div></div>

                    </div>
                </div>
            </el-form>

            <div class="operation">
                <el-button @click="cancelChange" size="small">取消</el-button>
                <el-button type="primary" @click="confirmChange" size="small">确定</el-button>
            </div>

        </div>

    </div>
</template>

<script>
const defaultOperationList = ['GREATER_THAN_EQUAL', 'LESS_THAN_EQUAL', 'EQUALS', 'BETWEEN'];
import FilterItem from './FilterItem';
import DapIconSvg from '../../../icon-svg';

export default {
    name: 'FilterPanel',
    props: {
        size: {
            type: String,
            default: 'mini',
        },
        effectMap: Object,
    },
    inject: {
        parentOptions: 'options',
        parentResult: 'result',
        operationList: 'operationList',
        getExcludeValue: 'excludeSelectedItems',
        getUnremoveKeys: 'unremoveKeys'
    },
    components: {
        FilterItem,
        DapIconSvg,
    },
    data () {
        return {
            selectedDict: {},
            creatorList: [],
            selectMetrics: {},
        };
    },

    mounted () {
        this.init(this.result, this.excludeValue);
    },

    computed: {
        options () {
            return this.parentOptions();
        },
        subOptionsList () {
            return this.options.filters.reduce((res, item) => [...item.children, ...res], []);
        },
        result () {
            return this.parentResult();
        },
        unremoveKeys () {
            return this.getUnremoveKeys();
        },
        slotNames () {
            return this.subOptionsList.filter(i => i.type === 'slot').map(i => i.key);
        },
        excludeValue () {
            return this.getExcludeValue();
        },
        clearIndex () {
            return this.options.filters.findIndex(i => i.clearable === true || i.clearable === undefined);
        },
    },

    methods: {
        init (val, excludeSelectedItems) {
            // 初始化
            this.selectedDict = Object.assign({}, val, excludeSelectedItems);
            if (this.options.metrics) {
                for (let metricGroup of this.options.metrics) {
                    const result = [];
                    for (let metric of metricGroup.children) {
                        const key = metric.key;
                        if (this.result[key]) {
                            result.push({
                                ...this.result[key],
                                ...metric,
                            })
                        }
                    }
                    this.selectMetrics = {
                        ...this.selectMetrics,
                        [metricGroup.key]: result
                    }
                }
            }
        },

        clearAll () {
            this.init(this.resetData());
            this.$emit('clearAll');
        },

        getFilterItem (key) {
            const subOptionsList = this.options.filters.reduce((res, item) => [...item.children, ...res], []);
            return subOptionsList.find(i => i.key === key) || {};
        },

        setResult ( { selectType, value }, excludeSelectedKey, exclude) {
            const deleteDict = {};
            if (this.effectMap && this.effectMap[selectType]) {
                this.effectMap[selectType].forEach(item => {
                    deleteDict[item] = undefined;
                    // 包含排除功能 - 所有关联的筛选项默认设置为false
                    const filterItem = this.getFilterItem(item);
                    if(filterItem.showExcludeSelected) {
                        deleteDict[filterItem.excludeSelectedKey] = false;
                    }
                });
            }
            this.selectedDict = Object.assign({}, this.selectedDict, {
                [selectType]: JSON.parse(JSON.stringify(value)),
                ...deleteDict,
            });

            // 多选弹框并且开启了排除功能
            if(excludeSelectedKey){
                this.selectedDict[excludeSelectedKey] = exclude;
            }
            this.$emit('changeTemp', { selectType, value, selectDict: this.selectedDict });
        },

        handleClose () {
            this.$emit('close');
        },

        resetData () {
            const res = {};
            for (let i = 0; i < this.subOptionsList.length; i++) {
                const option = this.subOptionsList[i];
                if (this.unremoveKeys.includes(option.key)) {
                    res[option.key] = this.selectedDict[option.key];
                    continue;
                }
                if (['text'].includes(option.type)) {
                    res[option.key] = '';
                } else if (['single', 'singleModal'].includes(option.type)) {
                    console.log('option.key', option.key);
                    res[option.key] = {};
                } else if (['multi', 'multiModal'].includes(option.type)) {
                    res[option.key] = [];
                }
                // 排除功能
                if(option.showExcludeSelected) {
                    res[option.excludeSelectedKey] = false;
                }
            }
            return res;
        },

        isDisabled (metricGroup, metric, item) {
            const selectedMetricKeys = this.selectMetrics[metricGroup.key].map(i => i.key);
            return selectedMetricKeys.includes(metric.key) && item.key !== metric.key;
        },

        addMetric (metricGroup) {
            if (!this.selectMetrics[metricGroup.key]) {
                this.selectMetrics = {
                    ...this.selectMetrics,
                    [metricGroup.key]: [],
                };
            }
            const selectedMetricKeys = this.selectMetrics[metricGroup.key].map(i => i.key);
            const metricsCanSelect = metricGroup.children.filter(i => !selectedMetricKeys.includes(i.key));
            const operationsList = metricsCanSelect[0].operations || defaultOperationList;
            this.selectMetrics[metricGroup.key] = [
                ...this.selectMetrics[metricGroup.key],
                {
                    key: metricsCanSelect[0].key,
                    operations: operationsList,
                    unit: metricsCanSelect[0].unit,
                    operation: operationsList[0],
                    value: '',
                    value2: '',
                },
            ]
        },

        getOperationList (operations) {
            const selfOperationList = operations || defaultOperationList;
            return this.operationList.filter(i => selfOperationList.includes(i.value));
        },

        removeMetric (metricGroup, item) {
            this.selectMetrics[metricGroup.key] = this.selectMetrics[metricGroup.key].filter(i => i.key !== item.key);
            this.selectedDict = {
                ...this.selectedDict,
                [item.key]: undefined,
            }
        },

        handleChangeOperation (item) {
            item.value = '';
            item.value2 = '';
        },

        handleChangeMetricKey (item, metricGroup) {
            const selectedItem = metricGroup.children.find(i => i.key === item.key);
            const operationsList = selectedItem.operations || defaultOperationList;
            item.operations = operationsList;
            item.operation = operationsList[0];
            item.unit = selectedItem.unit;
            item.value = '';
            item.value2 = '';
        },

        cancelChange () {
            this.handleClose();
            this.resetData();
        },

        confirmChange () {
            if (this.$refs.form) {
                this.$refs.form.validate().then(res => {
                    const metricsDict = Object.keys(this.selectMetrics)
                        .reduce((res, item) => [...res, ...this.selectMetrics[item]], [])
                        .reduce((res, item) => ({...res, [item.key]: {value: item.value, value2: item.value2, operation: item.operation}}), {});
                    this.$emit('changeFilter', { ...this.selectedDict, ...metricsDict });
                    this.handleClose();
                })
            } else {
                this.$emit('changeFilter', this.selectedDict);
                this.handleClose();
            }
        }

    },
};
</script>


<style lang="scss">
.relative {
    position: relative;
}
.dap-filter-panel {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: red;
    overflow-y: visible;

    .list-arrow2 {
        width: 0;
        height: 0;
        position: absolute;
        top: -5px;
        left: 30px;
        z-index: 999;
        border-width: 0 8px 8px;
        border-style: solid;
        border-color: transparent transparent #FFF;
    }

    .clear-all {
        position: absolute;
        right: 0px;
        top: 0px;
        z-index: 999;

        button {
            span {
                font-size: 12px;
            }
        }
    }

    .data-block {
        position: absolute;
        z-index: 998;
        top: 32px;
        left: 0;
        width: 100% ;
        background-color: #fff;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin: 5px 0;
        box-sizing: border-box;
        padding: 14px 30px 24px 30px;

        .data-block-title {
            text-align: left;
            color: #333333;
            font-weight: bold;
            font-size: 14px;
        }

        .select-area {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
            flex-wrap: wrap;
            margin: 20px 0 0 20px;
            overflow-y: visible;

            .item {
                min-width: 320px;
                margin-bottom: 20px;
            }
        }

        @media screen and (min-width: 2360px){
            .select-area {
                grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
            }
        }

        .option-select-area {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
            flex-wrap: wrap;
            margin: 20px 0 0 20px;
            overflow-y: visible;
            .add-item {
                width: 460px;
                height: 28px;
                box-sizing: border-box;
                border: 1px dashed #999999;
                &:hover {
                    border-color: #4284F4;
                    color: #4284F4;
                }
            }
            .option-item {
                min-width: 500px;
                margin-bottom: 20px;

                .delete-icon-box {
                    width: 20px;
                    height: 20px;
                    border-radius: 2px;
                    &:hover {
                        background: #F9F9F9;
                    }
                }

                .range-input {
                    box-sizing: border-box;
                    border: 1px solid #DCDFE6;
                    outline: 1px #DCDFE6;
                    border-radius: 4px;
                    height: 28px;
                    z-index: 100;
                }
            }
        }
    }

    .operation {
        text-align: right;
        button {
            width: 80px;
            font-size: 12px;
        }
    }

}
</style>
